/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactreason1Inputs */

const de__field_contactreason1 = /** @type {(inputs: _Field_Contactreason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktgrund`)
};

/**

* @param {_Field_Contactreason1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactreason1 = /** @type {((inputs?: _Field_Contactreason1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactreason1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactreason1(inputs)
});
export { _field_contactreason1 as "_field_contactReason" }